






























































































import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import { Contact } from '@/modules/Contact/interfaces/contact'
import RelationFormDialog from '@/modules/AccountContactRelation/components/RelationFormDialog.vue'
import RelationDialog from '@/modules/AccountContactRelation/scripts/account-contact-relation-dialog'
import { formatPhoneNumber } from '@/utils/phoneNumberFormat'

import AccountDialog from '../../Account/scripts/account-dialog'

@Component({
  components: {
    FoldingCard,
    AppDialog,
    RelationFormDialog
  }
})
export default class ContactDetailAccount extends mixins(AccountDialog, RelationDialog) {
  @Prop({ type: Object as () => Contact }) readonly contact!: Contact

  contactId: number | null = null

  tableColumn = [
    { field: 'name',
      title: 'Account Name',
      slots: { default: 'name_default' },
      resizable: true
    },
    { field: 'recordName',
      title: 'Account Record Name',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.recordType ? row.recordType.name : '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'phone',
      title: 'Phone',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.phone ? formatPhoneNumber(row.phone, row.countryCode) : '-')
        ]
      }
      },
      resizable: true
    },
    { title: 'Ext',
      field: 'extensionNumber',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.extensionNumber ? row.extensionNumber : '-')
        ]
      }
      },
      width: 80,
      sortable: false
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  get accounts () {
    return this.contact.accounts || []
  }

  get relatedAccounts () {
    return this.contact.relatedAccounts || []
  }

  routeTo (name: string, params: any) {
    this.$router.push({
      name,
      params
    })
  }

  routeToDetail (item: any) {
    this.routeTo('AccountDetailDetail', {
      id: item.id
    })
  }

  routeToRelationship (e: Event, item: any) {
    e.preventDefault()
    e.stopPropagation()
    this.routeTo('AccountContactRelationDetail', {
      id: item.relation.id
    })
  }

  newAccount (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.contactId = Number(this.contact.id)
    this.showAcctEditDialog(e)
  }

  newRelation (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.showRelationEditDialog(e)
  }

  async deleteAcctConfirm () {
    await this.deleteAcctPost()
    this.onFormSuccess()
  }

  routeToAllList (type: string) {
    this.$router.push({
      name: 'AccountAllList',
      params: {
        id: this.contact.id + '',
        type: type
      }
    })
  }

  @Emit('refresh')
  onFormSuccess () {
    // do nothing
  }
}
